import React, { Fragment, useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { createOrderAction } from '../../../redux/actions/orderActions'
import { uploadToCloudinary } from '../../../utils/uploadToCloudinary'
import store from "../../../store"

const OrderForm = ({ reservation, timeLeft }) => {
    const dispatch = useDispatch()

    const [order_number, setorder_number] = useState('')
    const [paypal_email, setpaypal_email] = useState('')
    const [order_proof_url, setorder_proof_url] = useState('')
    const [order_proof_preview, setorder_proof_preview] = useState('')
    const [product_price, setproduct_price] = useState('')

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (setImage, setPreview) => (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        } else {
            alert("Only PNG and JPG files are allowed!");
        }
    };

    const handleFileChange = (setImage, setPreview) => (e) => {
        const file = e.target.files[0];
        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        } else {
            alert("Only PNG and JPG files are allowed!");
        }
    };

    const displayID = String((reservation.id)).padStart(6, '0');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!order_number || !paypal_email || !order_proof_url || !product_price) {
            toast.error("Please fill in all required fields");
            return;
        }
        try {
            store.dispatch({ type: "UPLOAD_START" });
            const orderProofURL = await uploadToCloudinary(
                order_proof_url,
                "orders",
                1,
                1
            );
            const data = {
                order_proof_url: orderProofURL,
                order_number,
                paypal_email,
                product_price,
                reservation_id: reservation.id,
            };
            dispatch(createOrderAction(data))
            store.dispatch({ type: "UPLOAD_END" });
        } catch (err) {
            store.dispatch({ type: "UPLOAD_RESET" });
            toast.error("Image upload failed. Please Check your Internet Connection and then try again.");
        }
    }

    const handleReset = () => {
        setorder_number('')
        setpaypal_email('')
        setorder_proof_url('')
        setorder_proof_preview('')
        setproduct_price('')
    }

    return (
        <Fragment>
            <form action="" className="w-full lg:w-[60%] bg-white rounded-2xl p-6 lg:p-8 border border-zinc-200/80 shadow-sm flex flex-col gap-6" onSubmit={handleSubmit}>
                {/* Info Badges */}
                <div className="flex flex-col sm:flex-row gap-4">
                    <div className="flex-1 bg-zinc-50 border border-zinc-100 rounded-xl p-4 flex flex-col gap-1">
                        <span className="text-xs font-bold text-zinc-500 uppercase tracking-wider">Product ID</span>
                        <span className="text-lg font-black text-zinc-900">#{displayID}</span>
                    </div>
                    <div className="flex-1 bg-rose-50 border border-rose-100 rounded-xl p-4 flex flex-col gap-1">
                        <span className="text-xs font-bold text-rose-500 uppercase tracking-wider">Reservation Time Remaining</span>
                        <span className="text-lg font-bold text-rose-600 font-mono">{timeLeft}</span>
                    </div>
                </div>

                {/* Inputs Row */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Order Number */}
                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-bold text-zinc-700">Order Number <span className="text-rose-500">*</span></label>
                        <input
                            type="text"
                            value={order_number}
                            onChange={(e) => setorder_number(e.target.value)}
                            className="w-full px-4 py-3 rounded-xl border border-zinc-200/80 shadow-sm focus:ring-2 focus:ring-sky-500/20 focus:border-sky-500 outline-none text-sm font-medium text-zinc-700 placeholder-zinc-400 bg-white transition-all"
                            placeholder="ex. 123456-789012-3456789"
                        />
                    </div>

                    {/* Customer Email */}
                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-bold text-zinc-700">Customer Email <span className="text-rose-500">*</span></label>
                        <input
                            type="email"
                            value={paypal_email}
                            onChange={(e) => setpaypal_email(e.target.value)}
                            className="w-full px-4 py-3 rounded-xl border border-zinc-200/80 shadow-sm focus:ring-2 focus:ring-sky-500/20 focus:border-sky-500 outline-none text-sm font-medium text-zinc-700 placeholder-zinc-400 bg-white transition-all"
                            placeholder="Customer@company.com"
                        />
                    </div>
                </div>

                {/* Product Price */}
                <div className="flex flex-col gap-2">
                    <label className="text-sm font-bold text-zinc-700">Product Price <span className="text-zinc-400 font-normal">(Estimated Product Price in USD)</span> <span className="text-rose-500">*</span></label>
                    <div className="relative flex">
                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                            <span className="text-zinc-500 font-bold">$</span>
                        </div>
                        <input
                            type="text"
                            value={product_price}
                            onChange={(e) => setproduct_price(e.target.value)}
                            className="w-full pl-8 pr-4 py-3 rounded-xl border border-zinc-200/80 shadow-sm focus:ring-2 focus:ring-sky-500/20 focus:border-sky-500 outline-none text-sm font-medium text-zinc-700 placeholder-zinc-400 bg-white transition-all"
                            placeholder="Product Price Value in USD"
                        />
                    </div>
                </div>

                {/* Order Picture */}
                <div className="flex flex-col gap-2">
                    <label className="text-sm font-bold text-zinc-700">Order Picture <span className="text-rose-500">*</span></label>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {/* Upload Area */}
                        <div
                            className={`border-2 border-dashed ${order_proof_preview ? 'border-zinc-200' : 'border-zinc-300'} hover:border-sky-500 bg-zinc-50/50 hover:bg-zinc-50 rounded-2xl p-6 flex flex-col items-center justify-center cursor-pointer transition-all min-h-[200px]`}
                            onDrop={handleDrop(setorder_proof_url, setorder_proof_preview)}
                            onDragOver={handleDragOver}
                            onClick={() => document.getElementById("orderproofInput").click()}
                        >
                            <input
                                id="orderproofInput"
                                type="file"
                                accept="image/png, image/jpeg"
                                onChange={handleFileChange(setorder_proof_url, setorder_proof_preview)}
                                className="hidden"
                            />
                            <div className="text-center flex flex-col items-center gap-2">
                                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm border border-zinc-100 text-zinc-400">
                                    <i className="fa-regular fa-image text-xl"></i>
                                </div>
                                <div className="text-sm text-zinc-600">
                                    <span className="font-bold text-sky-600">Click to upload</span> or drag and drop
                                </div>
                                <div className="text-xs text-zinc-400">PNG or JPG only</div>
                            </div>
                        </div>

                        {/* Preview Area */}
                        {order_proof_preview && (
                            <div className="border border-zinc-100 rounded-2xl p-4 bg-zinc-50/50 flex items-center justify-center overflow-hidden min-h-[200px]">
                                <img
                                    src={order_proof_preview}
                                    alt="Preview"
                                    className="max-w-full max-h-[180px] object-contain rounded-lg shadow-sm"
                                />
                            </div>
                        )}
                    </div>
                </div>

                {/* Buttons */}
                <div className="flex justify-start gap-4 mt-2">
                    <button 
                        className="px-6 py-2.5 bg-white border border-zinc-200 hover:border-zinc-300 text-zinc-600 hover:text-zinc-700 font-bold text-sm rounded-xl transition-all shadow-sm hover:shadow" 
                        onClick={handleReset} 
                        type="button"
                    >
                        Reset
                    </button>
                    <button 
                        className="px-6 py-2.5 bg-gradient-to-br from-sky-500 to-indigo-600 text-white font-bold text-sm rounded-xl transition-all shadow-sm hover:shadow-md hover:shadow-sky-500/10 hover:scale-[0.98]" 
                        type="submit"
                    >
                        Submit Order
                    </button>
                </div>
            </form>
        </Fragment>
    )
}

export default OrderForm